// Start Page. Page shown after the user logs in. Contains the main menu of the app and
// ticket input. When a user scans a ticket, and if the ticket exist, the user will
// asked whether they want to update the ticket or check out. If check is selected,
// the check out will be processed and sent to the printer.
// If update is selected, the user will be redirected to the update
// the car and location information.
// If ticket does not exist, the user will be directed
// to add the car and location information.

import React from 'react';
import styles from '../css/mainPage.module.css';
import UpdatedDash from '../components/updatedDash';
import { useRef, useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { serverURL } from '../helpers/dataServerURL';
import { FaRegCheckSquare, FaRegWindowClose } from 'react-icons/fa';
import { convertToDatabaseDateTime } from '../helpers/timeDifference';
import { calculateTimeDifference } from '../helpers/timeDifference';
import ModifyTicketLoc from '../components/ModifyTicketLoc';

import {
  getCheckoutTicketData,
  postCheckOut,
  deleteTicketLocation,
  showTicketInformation,
  findTicketLocation,
  listOccupiedSpaces,
  insertTicketToMove,
  getTicketsToBeMoved,
  doesEmployeeCardExist,
  doesTicketExistInDailyCheckOuts,
  fetchUserMode,
  updateCheckOutWithEmpCard,
  findAttendantName,
  updateTargetTicket,
  getBlockingSpaces,
  fetchTicketFromCheckoutTbl,
} from '../helpers/databaseAPI';
// import blockingSpaces from '../jsonFIles/blockingSpaces.json';
import { useReactToPrint } from 'react-to-print';
import PrintContainer from '../components/PrintContainer';
import Modal from '../components/Modal';
import { AppContext } from '../store/context/context';

function MainPage() {
  const startRef = useRef(null);
  const legendRef = useRef(null);
  const contentRef = useRef();
  const updateBtnRef = useRef(null);
  const checkOutBtnRef = useRef(null);
  const cardInputRef = useRef(null);
  const [isTktFound, setIsTktFound] = useState(false);
  const navigate = useNavigate();
  const [scannedTicket, setScannedTicket] = useState(null);
  const loginURL = serverURL.server.url;
  const [ticketNumber, setTicketNumber] = useState('');
  const [locator, setLocator] = useState('');
  const [carInfo, setCarInfo] = useState('');
  const [colorInfo, setColorInfo] = useState('');
  const [licenseInfo, setLicenseInfo] = useState('');
  const [sectionInfo, setSectionInfo] = useState('');
  const [laneInfo, setLaneInfo] = useState('');
  const [checkoutStatus, setCheckOutStatus] = useState('');
  const [spotInfo, setSpotInfo] = useState('');
  const [checkIn, setCheckIn] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [occupiedSpaces, setOccupiedSpaces] = useState([]);
  const [empCardNumber, setEmpCardNumber] = useState(null);
  const [lastScannedCard, setLastScannedCard] = useState(null);
  const [empFullName, setEmpFullName] = useState('');
  const [userStatus, setUserStatus] = useState(1); //Important so that select default is 0
  const [ticketIsRetrieved, setTicketIsRetrieved] = useState(false); //If ticket exist in check out table, it will be retrieved then true. If not, false.
  const [retrievedTicket, setRetrievedTicket] = useState([]); //If ticket exist in check out table, it will be retrieved then true. If not, false.
  const userModeCTX = useContext(AppContext);
  const [showRetrievedTicketModal, setShowRetrievedTicketModal] = useState(false);
  const [refresh, setRefresh] = useState(0);

  // const context = useContext(AppContext);
  // This state is used to store the occupied spaces in the lane of the target ticket.
  // It is used to display the occupied spaces.
  // It is updated when the user clicks on the check out button and when the component mounts.
  // It is also used to update the occupied spaces when the user
  // checks out a ticket and modifies the car location.
  // Using storage like local storage to store the occupied spaces
  // because it allows us to persist the data across page reloads and
  // component unmounts. This way, if the user refreshes the page or
  // navigates away and comes back, we can still access the occupied spaces
  // data without losing it. It also allows us to share the occupied spaces
  // data across different components if needed.

  // const [ticketsToMove, setTicketsToMove] = useState(() => {
  //   const storedSpaces = localStorage.getItem('ticketsToMove');
  //   console.log('storedSpaces=', storedSpaces);
  //   return storedSpaces ? JSON.parse(storedSpaces) : [];
  // });
  const [ticketsToMove, setTicketsToMove] = useState([]);
  // const ticketsToMoveRef = useRef();
  const targetTicketLaneRef = useRef(null);
  const resultRef = useRef(null);
  // const location = useLocation();

  // Helper to update both together
  // function addTicketsToMove(newTickets) {
  //   ticketsToMoveRef.current = [...ticketsToMoveRef.current, ...newTickets];
  //   setTicketsToMove(ticketsToMoveRef.current); // triggers re-render for the table
  // }

  // function listBlockedSpaces() {
  //   const blocked = blockingSpaces.filter((space) => space.MaxLiftSpaces > 0);
  //   return blocked;
  // }

  convertToDatabaseDateTime(new Date());

  useEffect(() => {
    // localStorage.setItem('ticketsToMove', JSON.stringify(ticketsToMove));
    async function updateMovedTickets() {
      const updatedList = await getTicketsToBeMoved(loginURL);

      console.log(updatedList, 'Updated List');
      updatedList && setTicketsToMove(() => updatedList.filter((t) => t.IsMoved >= 0));
    }
    updateMovedTickets();

    //   // context.setTicketsToBeMoved(ticketsToMove);
  }, [loginURL, refresh]);

  useEffect(() => {
    function focusOnStart() {
      startRef.current.focus();
    }
    focusOnStart();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(false);

      startRef.current.focus();
    }, 3000);

    //Cleanup in case component unmounts early
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isModalOpen) return;
    if (!locator || locator === null) {
      console.error('Locator is null');
      return;
    }
    const timer = setTimeout(async () => {
      try {
        handlePrint();
        await postCheckOut(
          loginURL,
          ticketNumber,
          locator,
          convertToDatabaseDateTime(new Date()),
          convertToDatabaseDateTime(checkIn),
          sectionInfo,
          laneInfo,
          checkoutStatus,
          spotInfo,
          calculateTimeDifference(checkIn, new Date()).hours,
          calculateTimeDifference(checkIn, new Date()).minutes,
          empCardNumber,
        );

        await deleteTicketLocation(loginURL, ticketNumber);
        setIsModalOpen(false);

        // Refocus input after modal closes
        // setTimeout(() => {
        //   startRef.current?.focus();
        // }, 100);
      } catch (err) {
        console.error('Checkout failed:', err);
      }
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [isModalOpen, locator, ticketNumber, checkIn]);

  useEffect(() => {
    async function fetchUserModeFromServer() {
      try {
        const userMode = await fetchUserMode(loginURL, userModeCTX.user);
        setUserStatus(userMode);
        console.log('Fetched user mode from server:', userModeCTX.user, userMode);
      } catch (error) {
        console.error('Error fetching user mode:', error);
      }
    }
    fetchUserModeFromServer();
  }, [loginURL, userModeCTX.user]);

  // Code below tries to set focus back on input element when the print or
  // cancel buttons are clicked on the print window. It did not work
  // useEffect(() => {
  //   function handleAfterPrint() {
  //     setTimeout(() => {
  //       startRef.current?.focus();
  //     }, 50);
  //   }
  //   window.addEventListener('afterprint', handleAfterPrint);

  //   return () => {
  //     window.removeEventListener('afterprint', handleAfterPrint);
  //   };
  // }, []);

  async function validateEmpCardNumber(card) {
    // if ((await doesEmployeeCardExist(loginURL, card)) !== '') {
    //   return true;
    // }
    // return false;
    return Boolean(await doesEmployeeCardExist(loginURL, card));
  }

  function resetAfterCheckout() {
    setScannedTicket(null);
    setTicketNumber('');
    setIsTktFound(false);
    setIsModalOpen(false);
    setEmpCardNumber('');
    // setCheckOutsArray([]);
    // Do NOT clear ticketsToMove here — keep it visible in the side table
    startRef.current?.focus();
  }

  const handlePrint = useReactToPrint({
    contentRef, //content to print, ContentRef is assigned. ContentRef is a required property
    // to the div containing ticket details. contentRef is defined using useRef hook
    // so that we can access the DOM element directly.
    // When handlePrint is called, it retrieves the current value of contentRef
    // (which is the div) and uses it as the content to print.
    // This allows us to print only the specific section of the page
    // that contains the ticket details.
    //I can change the paper size by adding this code line size: 800mm 200mm margin:0;
    documentTitle: `Ticket_${ticketNumber}_Receipt`, // Title of the printed document
    pageStyle: `
      @page {
        size: 80mm 250mm; 
        margin: 0;
      }
  
      html,body {
        background: white;
         -webkit-print-color-adjust: exact;
         print-color-adjust:exact
       }
    
      `, // Custom CSS for the printed page to ensure it fits on a receipt
    // and has a white background

    // This code returns focus to the input referenced as startRef. The above code
    // that start with "`" (backward tick) is a css code and should not be
    // mixed with useReactToPrint javascript options. I can use either
    // startRef.current.focus or reload the page
    onAfterPrint: () => {
      setTimeout(() => {
        // startRef.current.focus();
        // window.location.reload(); This resets the entire screen including the side panel table. Replace with the function below
        resetAfterCheckout();
      }, 150);
    },
  });

  async function findBlockingSpaces() {
    let tempArray = [];
    const data = await getCheckoutTicketData(loginURL, ticketNumber);
    const tkt = await findTicketLocation(loginURL, ticketNumber);
    targetTicketLaneRef.current = tkt.LaneNum;
    console.log('Target ticket', tkt, targetTicketLaneRef.current, tkt.Ticket);
    const occupied = await listOccupiedSpaces(loginURL, tkt?.SectionName, tkt?.LaneNum, ticketNumber);
    const blocked = await getBlockingSpaces(loginURL, tkt?.SectionName, tkt?.SpaceNum);

    if (blocked) {
      let blockedArray = blocked.split(',');
      console.log(blockedArray, occupied, 'Spaces from DB');
      setOccupiedSpaces(occupied);
      tempArray = blockedArray.map((s) => occupied.find((space) => space.SpaceNum === Number(s))).filter(Boolean);
      //filter(Boolean) removes undefined if no match
      console.log(tempArray, 'Temp array');
      setTicketsToMove([...ticketsToMove, ...tempArray]);

      for (const record of tempArray) {
        console.log('Processing record:', record);

        await insertTicketToMove(
          loginURL,
          record.Ticket,
          record.Locator,
          record.SectionName,
          record.LaneNum,
          record.SpaceNum,
          record.IsMoved,
        );
      }
    }

    // const updatedList = await getTicketsToBeMoved(loginURL);
    // setTicketsToMove(updatedList.filter((t) => t.IsMoved === 1));

    const t = data[0];
    // setCheckOutsArray(data);
    setTicketNumber(t?.Ticket);
    setLocator(t?.Locator);
    setCheckIn(new Date(t?.TicketAdded).toLocaleString());
    setCarInfo(t?.CarMake);
    setColorInfo(t?.CarColor);
    setLicenseInfo(t?.LicensePlate);
    setSectionInfo(t?.SectionName);
    setCheckOutStatus('Pending');
    setLaneInfo(t?.LaneNum);
    setSpotInfo(t?.SpaceNum);
    setIsModalOpen(true);
    setScannedTicket('');
    setIsTktFound(false);
  }

  // Function to handle assigning a card number to check out.
  // It is called when the user scans a card number and presses enter.
  async function handleCardScan(cardNumber) {
    const employeeName = await findAttendantName(loginURL, cardNumber);
    if (employeeName) {
      await updateCheckOutWithEmpCard(loginURL, ticketNumber, cardNumber, employeeName.FullName, 'Assigned');
      setEmpFullName(employeeName);

      const exitingTkt = await fetchTicketFromCheckoutTbl(loginURL, ticketNumber);
      console.log('updated exiting ticket', ticketNumber, exitingTkt[0].LaneNum, exitingTkt);
      for (const row of ticketsToMove) {
        await updateTargetTicket(loginURL, ticketNumber, row.Ticket, exitingTkt[0].LaneNum);
        console.log('updated blocking ticket', row.Ticket, ticketNumber, exitingTkt[0].LaneNum, exitingTkt);
      }
      console.log('Employee name and card number', empCardNumber, empFullName, employeeName);

      setScannedTicket('');
      setEmpCardNumber('');
      // window.location.reload();
      // Force ModifyTicketLoc to remount
      setRefresh((prev) => prev + 1);
    } else {
      alert(`Employee name with card number ${cardNumber} does not exist`);
    }
  }

  return (
    // Use the below div when testing the Modify Car Location table.
    // It will show the table on the right side of the screen. The main page content will be on the left side of the screen.
    <div className={styles.topContainer}>
      <div className={styles.page}>
        <div>
          <div className={styles.headerContainer}>
            <h1 className={styles.headerLabel}>
              <span>
                <img src={require('../assets/SpotFinderLogo.png')} alt="SpotFinder Logo" className={styles.logo} />
              </span>
              Spot Finder App - Scan Ticket Below
            </h1>

            <div>
              <h3 style={{ fontSize: '18px', color: 'white' }}>
                Deliver with care, deliver on time, one car at a time.
              </h3>
            </div>
          </div>
        </div>
        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '700px' }}>
          <StartUp cashier={() => setUserStatus(1)} dispatcher={() => setUserStatus(2)} />
        </div> */}
        {showRetrievedTicketModal ? (
          <div
            style={{
              color: 'white',
              marginBottom: '10px',
              fontSize: '24px',
              textAlign: 'center',
              backgroundColor: 'green',
              padding: '12px',
              borderRadius: '15px',
              width: '800px',
            }}
          >
            Last check out ticket number {ticketNumber} is assigned to {empFullName.FullName}
          </div>
        ) : null}
        <div
          className={styles.bottomContainer}
          style={{ background: 'linear-gradient(90deg,#3dd9b3,transparent)' }}
        >
          <fieldset className={styles.inputFields} ref={legendRef}>
            <legend className={styles.inputLegend}>Scan Ticket</legend>
            <input
              ref={startRef}
              type="number"
              // step={1} //tells the browser to only allow whole numbers.
              className={styles.ticketInput}
              placeholder="Scan ticket"
              value={scannedTicket || ''}
              required
              // async wait is used because the async return a promise in the findTicket function
              // If I compare the result of findTicket===null, it will not return true because
              // promise = null false
              // async returns promise

              onKeyUp={async (e) => {
                if (e.key === 'Enter') {
                  if (scannedTicket) {
                    resultRef.current = await showTicketInformation(loginURL, scannedTicket);
                    // If ticket exist in the daily check out table, set ticketIsRetrieved to true.
                    // This will be used to determine if the ticket has already been checked out today.
                    const ticketExists = await doesTicketExistInDailyCheckOuts(loginURL, scannedTicket);
                    console.log('Ticket exists in daily check out table: ', ticketExists.exists);

                    if (ticketExists.exists === true) {
                      setTicketIsRetrieved(true);
                      setRetrievedTicket(ticketExists.ticket);
                      console.log(
                        'Ticket is retrieved from daily check out table: ',
                        ticketExists.exists,
                        ticketExists.ticket,
                        retrievedTicket,
                        userStatus,
                        ticketIsRetrieved,
                      );
                      setTimeout(() => {
                        // Focus on card number input for dispatcher to scan employee card
                        // Timer is used to allow the input to be rendered before focusing on it.
                        cardInputRef.current.focus();
                      }, 500);
                    }

                    // If ticket is not found in the occupied spaces table,
                    // and ticket not found in check out table then navigate to ticket entry page.
                    if (!ticketExists.exists && resultRef.current === null) {
                      setIsTktFound(false);
                      navigate('/ticketEntry', { state: { newTicket: scannedTicket } });
                      console.log('Pressed Enter: ', scannedTicket);
                    }

                    if (resultRef.current !== null && !ticketExists.exists) {
                      setIsTktFound(true);
                      if (userStatus > 0) {
                        setTimeout(() => {
                          checkOutBtnRef.current.focus();
                        }, 100);
                      }
                    }
                  }
                }
              }}
              /* Prevents decimal point or comma from being entered */
              onKeyDown={(e) => {
                if (e.key === '.' || e.key === ',' || e.key === '+' || e.key === '-') {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                // If input is empty, the buttons will be disabled when the isTktFount is false
                if (startRef.current.value.trim() === '') {
                  setScannedTicket(null);
                  setTicketNumber(null);
                  setIsTktFound(false);
                } else {
                  setScannedTicket(e.target.value);
                  setTicketNumber(e.target.value);
                }
                setShowRetrievedTicketModal(false);
              }}
            />
          </fieldset>
          {/* {userStatus === 1 ? ( //Cashier */}
          <button
            ref={checkOutBtnRef}
            disabled={!scannedTicket || !isTktFound ? true : false}
            style={{
              backgroundColor: isTktFound ? 'blue' : '#ccc',
              display: ticketIsRetrieved === true && userStatus > 0 && !isTktFound ? 'none' : 'block',
            }}
            onClick={async () => {
              // await checkOutHandle();
              await findBlockingSpaces();
            }}
          >
            {isTktFound ? (
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                {' '}
                <FaRegCheckSquare size="24px" /> Check Out
              </span>
            ) : (
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                <FaRegWindowClose /> Check Out
              </span>
            )}
          </button>
          {/* ) : userStatus === 2 ? ( //Dispatcher */}
          <fieldset
            className={styles.inputFields}
            style={{
              backgroundColor: !isTktFound && userStatus > 0 && !ticketIsRetrieved ? '#ccc' : '#fff',
              display: !isTktFound && userStatus > 0 && ticketIsRetrieved ? 'flex' : 'none',
            }}
            ref={legendRef}
          >
            <legend
              className={styles.inputLegend}
              style={{
                display: !isTktFound && userStatus > 0 && ticketIsRetrieved ? 'block' : 'none',
              }}
            >
              Scan Employee Card
            </legend>
            <input
              style={{
                backgroundColor: !isTktFound && userStatus > 0 && !ticketIsRetrieved ? '#ccc' : '#fff',
                display: !isTktFound && userStatus > 0 && ticketIsRetrieved ? 'block' : 'none',
              }}
              ref={cardInputRef}
              type="number"
              // step={1} //tells the browser to only allow whole numbers.
              className={styles.empCardInput}
              placeholder="Scan employee card"
              value={empCardNumber || ''}
              required
              // async wait is used because the async return a promise in the findTicket function
              // If I compare the result of findTicket===null, it will not return true because
              // promise = null false
              // async returns promise

              onKeyUp={async (e) => {
                const card = e.target.value;
                if (e.key === 'Enter') {
                  if (validateEmpCardNumber(e.target.value)) {
                    setEmpCardNumber(card);
                    setLastScannedCard(card);
                    await handleCardScan(card);
                    console.log('card found', e.target.value);
                    setShowRetrievedTicketModal(true);

                    setTimeout(() => {
                      startRef.current.focus();
                    }, 100);
                  } else {
                    alert('Employee card number does not exist');
                  }
                }
              }}
              // Prevents the characters in the code below from appearing in input
              onKeyDown={(e) => {
                if (e.key === '.' || e.key === ',' || e.key === '+' || e.key === '-') {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                setEmpCardNumber(e.target.value);
                console.log('Card Number', empCardNumber);
              }}
            />
          </fieldset>

          <button
            ref={updateBtnRef}
            disabled={!scannedTicket ? true : false}
            style={{
              backgroundColor: isTktFound ? 'blue' : '#ccc',
              display: ticketIsRetrieved === true && userStatus >= 0 && !isTktFound ? 'none' : 'block',
            }}
            //   isTktFound
            //     ? { backgroundColor: 'blue', width: '250px' }
            //     : { backgroundColor: '#ccc', width: '250px' }lock' }

            onClick={() => {
              // result = await showTicketInformation(loginURL, scannedTicket);
              scannedTicket &&
                navigate('/ticketEntry', { state: { targetTicket: resultRef.current, deleteTicket: true } });
            }}
          >
            {isTktFound ? (
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                {' '}
                <FaRegCheckSquare size="24px" /> Update Ticket
              </span>
            ) : (
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                <FaRegWindowClose /> Update Ticket
              </span>
            )}
          </button>
        </div>

        <Modal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
        >
          <div ref={contentRef} className={styles.checkOutContainer}>
            <PrintContainer
              ticketNumber={ticketNumber}
              locator={locator}
              // checkIn={checkIn}
              // stayHrsRef={stayHrsRef}
              // stayMinRef={stayMinRef}
              carInfo={carInfo}
              colorInfo={colorInfo}
              licenseInfo={licenseInfo}
              sectionInfo={sectionInfo}
              laneInfo={laneInfo}
              spotInfo={spotInfo}
              empCard={empCardNumber}
              barcode={ticketNumber}
            />
          </div>
        </Modal>
        <div>
          {/* <ActivitiesTable /> */}
          {/* <TopDashboard /> */}
          <UpdatedDash />
        </div>
      </div>
      <div>
        {/* refresh must be a key and not a prop for the component to remount
      The issue was the ModifyTicketLoc was not being remounted when I used 
      refresh as prop.
      */}
        <div className={styles.modifySpotContainer}>
          <ModifyTicketLoc
            ticketsToMove={ticketsToMove}
            setTicketsToMove={setTicketsToMove}
            loginURL={loginURL}
            changedTkt={ticketNumber}
            key={refresh}
          />
        </div>
      </div>
    </div>
  );
}

export default MainPage;
